export default __webpack_public_path__ + "static/media/car.70f1bcf2.svg";